<template>
  <!-- Add License pop up -->
  <b-modal id="addLicenseModal" centered size="lg" no-close-on-backdrop>
    <template #modal-header>
      <div class="addLicense-header text-center">
        <h4>Add License</h4>
        <b-button variant="close-btn" class='btn-container' @click="closeModal">
          <i class="fas fa-times" />
        </b-button>
      </div>
    </template>
    <b-container fluid>
      <div class="addLicense-form">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
          <form @submit.stop.prevent="handleSubmit(addLicense)" ref="addLicenseContainer">
            <div class="form-group row">
              <input-select :rules="{ required: true }" labelFor="state" labelName="State" inputName="state"
                :vmodel.sync="form.state" :options="states" defaultOption="Select Your State"
                formGroupClass="col-xxl-6 col-lg-6 col-md-6 mb-3" inputClass="form-control" />

              <input-text :rules="{ required: true, regex: /^[a-zA-Z0-9]*$/ }" labelFor="license_number"
                labelName="License Number" inputName="license_number" :vmodel.sync="form.license_number"
                input-type="text" formGroupClass="col-xxl-6 col-lg-6 col-md-6 mb-3" />
            </div>

            <div class="form-group row">
              <div class="col-xxl-6 col-lg-6 col-md-6 mb-3">
                <validation-provider name="License Valid Until" rules="required" v-slot="{ errors, valid }">
                  <label for="">
                    License Valid Until
                    <span class="required-indc">*</span>
                  </label>
                  <br />
                  <date-picker :input-class="getDatePickerClass(errors[0], valid)" placeholder="License Valid Until"
                    type="date" value-type="format" v-model="form.license_exp_date" :default-value="new Date()"
                    :disabled-date="disabledBeforeToday" />
                  <span class="invalid-date invalid-feedback">
                    {{ errors[0] }}
                  </span>
                </validation-provider>
              </div>

              <input-multi-select :rules="{ required: true }" labelFor="resident" labelName="Resident"
                inputName="resident" :vmodel.sync="form.license_resident" :options="residents.map((type) => type.value)"
                :custom-label="(opt) => residents.find((x) => x.value == opt).text
                  " formGroupClass="col-xxl-6 col-lg-6 col-md-6 mb-3" placeholder="Select Option" />
            </div>

            <div class="form-group row">
              <input-file :rules="{ mimes: mimeTypes, size: 5120 }" labelFor="license_doc"
                labelName="Upload License File(PDF,JPG or PNG)" inputName="license_doc" :vmodel.sync="form.license_doc"
                :acceptMimeTypes="mimeTypes" formGroupClass="col-xxl-12 col-lg-12 col-md-12 mb-3" ref="licenseFileInput" />
            </div>
            <div class="form-group text-center mb-3 mt-3">
              <b-button class="univ-btn" type="submit" :disabled="isCreate">
                <template v-if="isCreate"> Adding ... </template>
                <template v-else> Add </template>
              </b-button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </b-container>
  </b-modal>
</template>
<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
export default {
  name: "AddLicenseModal",
  props: {
    agent: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        state: null,
        license_resident: null,
        license_doc: null,
        license_number: "",
        license_exp_date: "",
        license_for: "DOWNLINE_REP"
      },
      states: Helper.getStates(),
      residents: [
        { value: 1, text: "Yes" },
        { value: 0, text: "No" },
      ],
      isCreate: false,
      mimeTypes: ["application/pdf", "image/jpeg", "image/jpg", "image/png"],
    };
  },
  watch: {
    'form.license_number'(newValue) {
      if (newValue) {
        this.form.license_number = newValue.toUpperCase();
      }
    }
  },
  methods: {
    getDatePickerClass(error, isValid) {
      let className = "";
      if (error) {
        className = "invalid-input-block";
      } else if (isValid) {
        className = "valid-input-block";
      } else {
        className = "";
      }
      return `${className} form-control`;
    },
    disabledBeforeToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    reset() {
      this.form = {
        state: null,
        license_resident: null,
        license_doc: null,
        license_number: "",
        license_exp_date: "",
        license_for: "DOWNLINE_REP"
      };
      if (this.$refs.licenseFileInput) {
        this.$refs.licenseFileInput.clearFile();
      }
    },
    closeModal() {
      this.$bvModal.hide("addLicenseModal");
      this.reset();
    },
    async addLicense() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }
      
      if (this.form.license_number) {
        this.form.license_number = this.form.license_number.toUpperCase();
      }
      
      let url;
      this.isCreate = true;
      url = `v3/license/add`;
      let formData = new FormData();
      formData.append("file", this.form.license_doc);
      formData.append("agent_id", this.getAgentId());
      formData.append("downline_rep", this.getAgentId());
      for (const [key, value] of Object.entries(this.form)) {
        if (value) {
          formData.append(key, value);
        }
      }
      if (!this.form.license_resident) {
        formData.append("license_resident", 0);
      }
      
       let loader = this.$loading.show();
      Api.post(url, formData)
        .then((res) => {
          this.$notify(res.data.message);
          this.closeModal();
          this.$emit("onSuccess");
        })
        .catch((err) => {
          this.$notify(err.response.data.message, "error");
        })
        .finally(() => {
          loader.hide();
          this.isCreate = false;
          if (this.$refs.licenseFileInput) {
            this.$refs.licenseFileInput.clearFile();
          }
        });
    },
    getAgentId() {
      return this.agent ? this.agent.agent_id : "";
    },
  },
};
</script>
<style scoped>
.addLicense-header {
  position: relative;
}

.addLicense-header h4 {
  margin: 0;
  font-weight: 600;
}

.btn-container {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.required-indc {
  color: #dc3545;
}

.invalid-date {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.univ-btn {
  background-color: #007bff;
  border-color: #007bff;
  padding: 10px 30px;
  font-weight: 500;
}

.univ-btn:hover {
  background-color: #0056b3;
  border-color: #004085;
}

.univ-btn:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
}

/* Add proper padding for validation error messages */
.invalid-feedback {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
  display: block;
}

/* Ensure consistent error styling for all form components */
::v-deep .invalid-feedback {
  margin-top: 0.25rem !important;
  font-size: 0.875em !important;
  color: #dc3545 !important;
  display: block !important;
}
</style>
